import * as React from 'react';
import * as PropTypes from 'prop-types';
import StyledBackArrow, { BackArrowIcon } from './styles/BackArrow';

var BackArrow = function BackArrow(_ref) {
  var onClick = _ref.onClick,
      render = _ref.render;
  var icon = React.createElement(BackArrowIcon, {
    type: "wind-arrow-left",
    onClick: onClick
  });
  return React.createElement(StyledBackArrow, null, typeof render === 'function' ? render(icon) : icon);
};

BackArrow.propTypes = {
  onClick: PropTypes.func,
  render: PropTypes.func
};
export default BackArrow;